import React, { useEffect, useState } from 'react'
import { PositionProperty } from 'csstype'
import { RoomType } from '../../../../models/Room'
import { isSafari } from '../../../DetectBrowser/DetectBrowser'

export const mappingIcons: Map<RoomType, string> = new Map()
mappingIcons.set(RoomType.Apartament, 'apartament')
mappingIcons.set(RoomType.Bed, 'bed')
mappingIcons.set(RoomType.Boat, 'boat')
mappingIcons.set(RoomType.Bungalow, 'bungalow')
mappingIcons.set(RoomType.Camper, 'camper')
mappingIcons.set(RoomType.BigHouse, 'house')
mappingIcons.set(RoomType.Lodge, 'maisonette')
mappingIcons.set(RoomType.Room, 'room')
mappingIcons.set(RoomType.House, 'smallhouse')
mappingIcons.set(RoomType.Studio, 'studio')
mappingIcons.set(RoomType.Tent, 'tent')
mappingIcons.set(RoomType.Villa, 'villa')

function RoomIcon({
                    alt,
                    title,
                    roomType,
                    iconType,
                    w = 24,
                    h = 24,
                    className,
                    position,
                  }: IRoomIcon) {
  const [href, setHref] = useState('')
  useEffect(() => {
    const roomIconName = mappingIcons.get(roomType)
    if (roomIconName === undefined) {
      return
    }

    import(`../../../../assets/room_types/${iconType}/${roomIconName}.png`)
      .then(src => setHref(src.default))
      .catch(() => setHref(''))
  }, [roomType, iconType])

  return (
    <img
      className={className}
      src={href}
      alt={alt}
      title={title}
      style={{
        height: h,
        position: position ? position : isSafari() ? 'relative' : 'absolute',
        width: w,
      }}
    />
  )
}

export default RoomIcon

export interface IRoomIcon {
  roomType: RoomType
  iconType: 'dark' | 'green' | 'light'

  alt?: string
  title?: string

  w?: number
  h?: number

  className?: string
  position?: PositionProperty
}
